export default `---
slug: traffic-simulation
title: "Traffic Simulation"
year: 2020
category: university
featured: false
tags: [Python, SUMO, NumPy, Pandas, Simulation]
thumbnail: /images/projects/4_first_python.png
description: "My very first Python project: simulating traffic light control for Monza's roads using the SUMO simulator. Where I learned Python and fell further in love with coding."
relatedLinks:
  - label: "Bachelor at Politecnico di Milano"
    href: /career/bachelor-polimi
---

![Coding at night](/images/projects/4_first_python.png)

This project is my very first time approaching Python, it's where I learnt this amazing language that I later used so much!

It happened during the first wave of the Covid-19 pandemic, and I was at my parent's home with a lot of time and my mom feeding me well and handling all the chores. (*Shout out to Mom for always taking care of us!*)

That semester in Uni I was doing 35 CFU worth of classes instead of the regular 30, and one of those classes was Automation and Control in Veichles, with the legendary [Professor Sergio Savaresi](https://scholar.google.com/citations?user=461TQ2cAAAAJ&hl=en).
Every year he selected few students to assign them projects with the PhD candidates, to do hands on stuff. Of course I wanted to participate in the initiative, projects are always more interesting and fun than class studies, and I also wanted to "get noticed" as I wanted (*and did*) do my Master Thesis in his research group.
*in hindsight, a bit overrated, but this is another story...*

**Now, to the project:**
The overall research idea was to install traffic sensors on some traffic lights in Monza, a city near Milan, in order to reduce the lines of cars.
The project was to simulate the cars and the traffic lights using the [SUMO simulator](https://www.eclipse.org/sumo/).
I was in a team with other two students, Edoardo *The Usual* and Lorenzo Nigro, and we had to create an interface in Python to configure the simulation, download the data and run analysis.
My part was on the output download and processing, and I used Numpy and Pandas to process the data.
This was my very first time using Python, and I was ***before LLMs***, so the process was a bit painful.
But the hussle and the effort were worth it, and I learnt a lot from this project - and had so much fun with my mates in the process!

*Nugget of the project: the control algorithm made by Edoardo was better performing than the PhD's one*
`;
